import type { Feature } from './types';

import { useGroupInfos } from './useGroupInfos';

export const useHasFeature = (feature: Feature) => {
  const { features } = useGroupInfos();

  return features.includes(feature);
};
